import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { debounceTime, filter } from 'rxjs/operators';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { ModalSeleccionarClienteComponent } from 'src/app/views/shared/modal-seleccionar-cliente/modal-seleccionar-cliente.component';
import { ModalAddEditReversoPagoComponent } from '../modal-add-edit-reverso-pago/modal-add-edit-reverso-pago.component';

@Component({
  selector: 'app-reverso-pagos-cabecera',
  templateUrl: './cabecera.component.html',
  styleUrls: ['./cabecera.component.scss']
})
export class CabeceraComponent implements OnInit {

  @Input() canAddReversoPago: boolean = false

  // Modales
  @ViewChild(ModalSeleccionarClienteComponent, { static: true }) modalSeleccionarCliente: ModalSeleccionarClienteComponent
  @ViewChild(ModalAddEditReversoPagoComponent, { static: true }) modalReverso: ModalAddEditReversoPagoComponent

  // Form
  formHeader: FormGroup

  // Outputs
  @Output() onSearch: EventEmitter<any> = new EventEmitter<any>()
  @Output() onSearchAll: EventEmitter<void> = new EventEmitter()

  // Data &  Tmp
  clienteSeleccionado: any = null
  filtersDisabled: boolean = false

  // Utils
  private log: any

  constructor(
    private clog: ConsoleService,
    private fb: FormBuilder,
    private rutService: RutService,
    private formValidatorsService: FormValidatorsService,
    private datesService: DatesService
  ) {
    this.log = this.clog.log('REVERSO-PAGOS-CABECERA')
  }

  ngOnInit() {
    this.createForm()
    this.formChangesSubscriptions()
  }

  private createForm() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.formHeader = this.fb.group({
      rutCliente: [null],
      fechaDesde: [initDate, [Validators.required]],
      fechaHasta: [currentDate, [Validators.required]]
    });
  }

  private formChangesSubscriptions() {
    this.formHeader.get("rutCliente").valueChanges
      .pipe(filter(Boolean), debounceTime(1000))
      .subscribe((rutCliente: string) => {
        this.modalSeleccionarCliente.searchByRut(rutCliente)
      })
  }

  openModalReverso() {
    this.modalReverso.show()
  }

  openModalSeleccionarClientes() {
    this.modalSeleccionarCliente.show()
  }

  onClienteSeleccionado({ data }) {
    this.clienteSeleccionado = data
    this.formHeader.get('rutCliente').setValue(this.rutService.AgregarDV(this.clienteSeleccionado.rut))
  }

  onClienteNoEncontrado() {
    this.clienteSeleccionado = null
  }

  // handleCheckTodos({ checked }) {
  //   this.filtersDisabled = checked
  //   this.formHeader.markAsPristine()
  //   this.formHeader.markAsUntouched()
  //   // if (checked) {
  //   //   this.clearForm()
  //   // }
  // }

  clearForm() {
    this.formHeader.markAsPristine()
    this.formHeader.markAsUntouched()
    this.clienteSeleccionado = null
    this.formHeader.get('rutCliente').setValue(null)
    this.formHeader.get('fechaDesde').setValue(null)
    this.formHeader.get('fechaHasta').setValue(null)
  }

  buscar() {
    if( this.formHeader.get('rutCliente').value === ''){
      this.clienteSeleccionado  = null;
    }

     this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid)
      return

    this.onSearch.emit(this.formHeader.value)
  }

  onSaveReverso(reverso) {
    this.buscar()
  }

}
